import Vue from "vue"
import Router from "vue-router"
import HelloWorld from "@/components/HelloWorld"
import AllPage from "@/components/AllPage"
import Disappear from "@/components/disappear"
import money from "../components/money/index"


Vue.use(Router)// 全局的路由

export default new Router({

  /* mode: 'history',*/
  routes: [
    {// 重定向路由；默认显示的链接
      path: "/",
      redirect: "/exhibition"
    },
    {
      path: "/disappear",
      name: "disappear",
      component: Disappear
    },
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["../components/login.vue"], resolve)
    },{
      path: "/resetPwd",
      name: "ResetPwd",
      component: (resolve) => require(["../components/resetPassword.vue"], resolve)
    },
    {
      path: "/",
      name: "首页",
      component: HelloWorld,
      children: [
        {
          path: "/terminal",
          name: "终端管理",
          meta: {
            index: 0
          },
          children: [
            {
              path: "/terminal",
              redirect: "/terminal/attribute"
            },
            {
              path: "/terminal/attribute",
              name: "属性",
              meta: {
                index: 0
              },
              component: (resolve) => require(["../components/terminal/select/attribute.vue"], resolve)
            },
            {
              path: "/terminal/instructions",
              name: "指令",
              meta: {
                index: 1
              },
              component: (resolve) => require(["../components/terminal/select/instructions.vue"], resolve)
            },
            {
              path: "/terminal/monitor",
              name: "监控",
              meta: {
                index: 2
              },
              component: (resolve) => require(["../components/terminal/select/monitor.vue"], resolve)
            },
            {
              path: "/terminal/upgrade",
              name: "升级",
              meta: {
                index: 3
              },
              component: (resolve) => require(["../components/terminal/select/upgrade.vue"], resolve)
            },
            {
              path: "/terminal/register",
              name: "统计",
              meta: {
                index: 4
              },
              component: (resolve) => require(["../components/terminal/select/register.vue"], resolve)
            },
            {
              path: "/terminal/statistics",
              name: "注册",
              meta: {
                index: 5
              },
              component: (resolve) => require(["../components/terminal/select/statistics.vue"], resolve)
            },
            {
              path: "/terminal/throughput",
              name: "流量",
              meta: {
                index: 6
              },
              component: (resolve) => require(["../components/terminal/select/throughput.vue"], resolve)
            },
            {
              path: "/terminal/setting",
              name: "设置",
              meta: {
                index: 7
              },
              component: (resolve) => require(["../components/terminal/select/setting.vue"], resolve)
            },
            {
              path: "/terminal/switchover",
              name: "切换",
              meta: {
                index: 8
              },
              component: (resolve) => require(["../components/terminal/select/switchover.vue"], resolve)
            },
            {
              path: "/terminal/dingzhi",
              name: "私人定制",
              meta: {
                index: 7
              },
              component: (resolve) => require(["../components/terminal/select/dingzhi.vue"], resolve)
            }
          ],
          component: (resolve) => require(["../components/terminal/index.vue"], resolve)
        },
        {
          path: "/material",
          name: "素材管理",
          meta: {
            index: 1
          },
          children: [
            {// 重定向，默认显示重定向的路由
              path: "/material",
              redirect: "/material/displayPage"
            },
            {
              path: "/material/displayPage",
              name: "显示页面",
              component: (resolve) => require(["../components/material/matechildren/displayPage.vue"], resolve)
            }
          ],
          component: (resolve) => require(["../components/material/index.vue"], resolve)
        },
        {
          path: '/material/explain',
          name: '素材上传说明',
          component: (resolve) => require(["../components/material/explain.vue"], resolve)
        },
        {
          path: "/program",
          name: "节目制作",
          meta: {
            index: 2
          },
          component: (resolve) => require(["../components/program/index.vue"], resolve)
        },
        {
          path: "/system",
          name: "系统",
          meta: {
            index: 3
          },
          children: [
            {// 重定向，默认显示重定向的路由
              path: "/system",
              redirect: "/system/index"
            },
            {
              path: "/system/index",
              name: "服务器配置",
              component: (resolve) => require(["../components/system/basics/index.vue"], resolve)
            },
            {
              path: "/system/mana",
              name: "权限管理",
              component: (resolve) => require(["../components/system/basics/mana"], resolve)
            },
            {
              path: "/system/enroll",
              name: "软件注册",
              component: (resolve) => require(["../components/system/basics/enroll"], resolve)
            },
            {
              path: "/system/logmana",
              name: "日志管理",
              component: (resolve) => require(["../components/system/basics/logmana"], resolve)
            },
            {
              path: "/system/help",
              name: "系统帮助",
              component: (resolve) => require(["../components/system/basics/help"], resolve) // 系统配置
            },
            {
              path: "/system/basics",
              name: "基础配置",
              component: (resolve) => require(["../components/system/basics/basics"], resolve) // 系统配置
            },
            {
              path: "/system/upan",
              name: "U盘导出",
              component: (resolve) => require(["../components/system/basics/Upan"], resolve) // 系统配置
            }
          ],
          component: (resolve) => require(["../components/system/index.vue"], resolve)
        },
        {
          path: "/task",
          name: "任务管理",
          meta: {
            index: 4
          },
          component: (resolve) => require(["../components/task/index.vue"], resolve)
        },
        {
          path: "/task/list", // 由于特殊的原因上传列表不能用children写在任务管理的子路由里，所以单独写的
          name: "上传列表",
          component: (resolve) => require(["../components/task/tasklist/index"], resolve)
        },
        {
          path: "/management",
          name: "客户管理",
          component: (resolve) => require(["../components/management/management.vue"], resolve)
        },
        {
          path: "/frogram",
          name: "节目发送",
          component: (resolve) => require(["../components/program/frogram.vue"], resolve)
        },
        {
          path: '/exhibition',
          name: '展示页面',
          component: (resolve) => require(["../components/exhibition/index"], resolve)
        },
        {
          path: "/money",
          name: "money",
          component: money,
          children: [
            {
              path: "/money",
              redirect: "/money/renew"
            },
            {
              path: "/money/renew",
              name: "renew",
              component: (resolve) => require(["../components/money/renew"], resolve)
            },
            {
              path: "/money/dilatation",
              name: "dilatation",
              component: (resolve) => require(["../components/money/dilatation"], resolve)
            },
            {
              path: "/money/orderList",
              name: "orderList",
              component: (resolve) => require(["../components/money/orderList"], resolve)
            }
          ]
        },
      ]
    },
    {// 登录首页路由
      path: "/auditTask",
      name: "auditTask",
      component: (resolve) => require(["@/components/auditTask/index.vue"], resolve)
    },
    {
      path: "/addprogram",
      name: "addprogram",
      component: (resolve) => require(["../components/addprogram/index.vue"], resolve)
    },
    {
      path: "/preview",
      name: "preview",
      component: (resolve) => require(["../components/program/preview.vue"], resolve)
    },
    {
      path: "/myExplain",
      name: "myExplain",
      component: (resolve) => require(["../components/system/basics/explain"], resolve) // 使用说明
    },
    {
      path: "/childDevice",
      name: "childDevice",
      component: (resolve) => require(["../components/childDevice/childDevice.vue"], resolve)
    },
    {
      path: "/cbsubtitles",
      name: "cbsubtitles",
      component: (resolve) => require(["../components/cbsubtitles/cbsubtitles"], resolve)
    },
    {
      path: "/applet",
      name: "applet",
      component: (resolve) => require(["../components/applet/applet"], resolve) // 小程序
    },
    {
      path: "/fullScreen",
      name: "FullScreen",
      component: (resolve) => require(["../components/terminal/select/FullScreen"], resolve) // 小程序
    },
    {
      path: "/404",
      name: "allPage",
      component: AllPage
    },{
      path: "/editPass",
      name: "editPass",
      component: (resolve) => require(["../components/editPass"], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js